import * as types from "../constants/home";

// getDashboard
export const getDashboardRequest = () => ({
  type: types.GET_DASHBOARD_REQUEST,
});

export const getDashboardSuccess = (response) => ({
  type: types.GET_DASHBOARD_SUCCESS,
  response,
});

export const getDashboardFailed = (response) => ({
  type: types.GET_DASHBOARD_FAILED,
  response,
});

// getUsers
export const getUsersRequest = (data) => ({
  type: types.GET_USERS_REQUEST,
  data,
});

export const getUsersSuccess = (response) => ({
  type: types.GET_USERS_SUCCESS,
  response,
});

export const getUsersFailed = (response) => ({
  type: types.GET_USERS_FAILED,
  response,
});

// getCourseUsers
export const getCourseUsersRequest = (data) => ({
  type: types.GET_COURSE_USERS_REQUEST,
  data,
});

export const getCourseUsersSuccess = (response) => ({
  type: types.GET_COURSE_USERS_SUCCESS,
  response,
});

export const getCourseUsersFailed = (response) => ({
  type: types.GET_COURSE_USERS_FAILED,
  response,
});

// getCourseMessages
export const getCourseMessagesRequest = (data) => ({
  type: types.GET_COURSE_MESSAGES_REQUEST,
  data,
});

export const getCourseMessagesSuccess = (response) => ({
  type: types.GET_COURSE_MESSAGES_SUCCESS,
  response,
});

export const getCourseMessagesFailed = (response) => ({
  type: types.GET_COURSE_MESSAGES_FAILED,
  response,
});


// getAdmins
export const getAdminsRequest = () => ({
  type: types.GET_ADMINS_REQUEST,
});

export const getAdminsSuccess = (response) => ({
  type: types.GET_ADMINS_SUCCESS,
  response,
});

export const getAdminsFailed = (response) => ({
  type: types.GET_ADMINS_FAILED,
  response,
});

// getCourses
export const getCoursesRequest = (offset, limit, isChat, search, category) => ({
  type: types.GET_COURSES_REQUEST,
  offset,
  limit,
  isChat,
  search,
  category,
});

export const getCoursesSuccess = (response, action) => ({
  type: types.GET_COURSES_SUCCESS,
  response,
  action,
});

export const getCoursesFailed = (response, action) => ({
  type: types.GET_COURSES_FAILED,
  response,
});

// getNewCourses
export const getNewCoursesRequest = (offset, search, category) => ({
  type: types.GET_NEW_COURSES_REQUEST,
  offset,
  search,
  category,
});

export const getNewCoursesSuccess = (response) => ({
  type: types.GET_NEW_COURSES_SUCCESS,
  response,
});

export const getNewCoursesFailed = (response) => ({
  type: types.GET_NEW_COURSES_FAILED,
  response,
});

// getWaitingCourses
export const getWaitingCoursesRequest = (offset, search, category) => ({
  type: types.GET_WAITING_COURSES_REQUEST,
  offset,
  search,
  category,
});

export const getWaitingCoursesSuccess = (response) => ({
  type: types.GET_WAITING_COURSES_SUCCESS,
  response,
});

export const getWaitingCoursesFailed = (response) => ({
  type: types.GET_WAITING_COURSES_FAILED,
  response,
});

// postCourse
export const postCourseRequest = (data) => ({
  type: types.POST_COURSE_REQUEST,
  data,
});

export const postCourseSuccess = (response) => ({
  type: types.POST_COURSE_SUCCESS,
  response,
});

export const postCourseFailed = (response) => ({
  type: types.POST_COURSE_FAILED,
  response,
});

// patchCourse
export const patchCourseRequest = (data) => ({
  type: types.PATCH_COURSE_REQUEST,
  data,
});

export const patchCourseSuccess = (response) => ({
  type: types.PATCH_COURSE_SUCCESS,
  response,
});

export const patchCourseFailed = (response) => ({
  type: types.PATCH_COURSE_FAILED,
  response,
});

// deleteCourse
export const deleteCourseRequest = (data) => ({
  type: types.DELETE_COURSE_REQUEST,
  data,
});

export const deleteCourseSuccess = (response) => ({
  type: types.DELETE_COURSE_SUCCESS,
  response,
});

export const deleteCourseFailed = (response) => ({
  type: types.DELETE_COURSE_FAILED,
  response,
});

// postCourseEnroll
export const postCourseEnrollRequest = (data) => ({
  type: types.POST_COURSE_ENROLL_REQUEST,
  data,
});

export const postCourseEnrollSuccess = (response) => ({
  type: types.POST_COURSE_ENROLL_SUCCESS,
  response,
});

export const postCourseEnrollFailed = (response) => ({
  type: types.POST_COURSE_ENROLL_FAILED,
  response,
});

// postApproveReq
export const postApproveReqRequest = (data, id) => ({
  type: types.POST_APPROVE_REQ_REQUEST,
  data,
  id,
});

export const postApproveReqSuccess = (response) => ({
  type: types.POST_APPROVE_REQ_SUCCESS,
  response,
});

export const postApproveReqFailed = (response) => ({
  type: types.POST_APPROVE_REQ_FAILED,
  response,
});

// getCourseEnrollReq
export const getCourseEnrollReqRequest = (data) => ({
  type: types.GET_COURSE_ENROLL_REQ_REQUEST,
  data,
});

export const getCourseEnrollReqSuccess = (response) => ({
  type: types.GET_COURSE_ENROLL_REQ_SUCCESS,
  response,
});

export const getCourseEnrollReqFailed = (response) => ({
  type: types.GET_COURSE_ENROLL_REQ_FAILED,
  response,
});

// getContent
export const getContentRequest = (id, con_type, offset) => ({
  type: types.GET_CONTENT_REQUEST,
  id,
  con_type,
  offset,
});

export const getContentSuccess = (response) => ({
  type: types.GET_CONTENT_SUCCESS,
  response,
});

export const getContentFailed = (response) => ({
  type: types.GET_CONTENT_FAILED,
  response,
});

// postContent
export const postContentRequest = (data) => ({
  type: types.POST_CONTENT_REQUEST,
  data,
});

export const postContentSuccess = (response) => ({
  type: types.POST_CONTENT_SUCCESS,
  response,
});

export const postContentFailed = (response) => ({
  type: types.POST_CONTENT_FAILED,
  response,
});

// patchContentReorder
export const patchContentReorderRequest = (id, data, title) => ({
  type: types.PATCH_CONTENT_REORDER_REQUEST,
  id,
  data,
  title,
});

export const patchContentReorderSuccess = (response) => ({
  type: types.PATCH_CONTENT_REORDER_SUCCESS,
  response,
});

export const patchContentReorderFailed = (response) => ({
  type: types.PATCH_CONTENT_REORDER_FAILED,
  response,
});

// postSubmitQuiz
export const postSubmitQuizRequest = (data) => ({
  type: types.POST_SUBMIT_QUIZ_REQUEST,
  data,
});

export const postSubmitQuizSuccess = (response) => ({
  type: types.POST_SUBMIT_QUIZ_SUCCESS,
  response,
});

export const postSubmitQuizFailed = (response) => ({
  type: types.POST_SUBMIT_QUIZ_FAILED,
  response,
});

// postQuiz
export const postQuizRequest = (data, id) => ({
  type: types.POST_QUIZ_REQUEST,
  data,
  id,
});

export const postQuizSuccess = (response) => ({
  type: types.POST_QUIZ_SUCCESS,
  response,
});

export const postQuizFailed = (response) => ({
  type: types.POST_QUIZ_FAILED,
  response,
});

// getQuizDetails
export const getQuizDetailsRequest = (id) => ({
  type: types.GET_QUIZ_DETAILS_REQUEST,
  id,
});

export const getQuizDetailsSuccess = (response) => ({
  type: types.GET_QUIZ_DETAILS_SUCCESS,
  response,
});

export const getQuizDetailsFailed = (response) => ({
  type: types.GET_QUIZ_DETAILS_FAILED,
  response,
});


// deleteContent
export const deleteContentRequest = (data) => ({
  type: types.DELETE_CONTENT_REQUEST,
  data,
});

export const deleteContentSuccess = (response) => ({
  type: types.DELETE_CONTENT_SUCCESS,
  response,
});

export const deleteContentFailed = (response) => ({
  type: types.DELETE_CONTENT_FAILED,
  response,
});

// deleteFolder
export const deleteFolderRequest = (data) => ({
  type: types.DELETE_FOLDER_REQUEST,
  data,
});

export const deleteFolderSuccess = (response) => ({
  type: types.DELETE_FOLDER_SUCCESS,
  response,
});

export const deleteFolderFailed = (response) => ({
  type: types.DELETE_FOLDER_FAILED,
  response,
});

// getNews
export const getNewsRequest = () => ({
  type: types.GET_NEWS_REQUEST,
});

export const getNewsSuccess = (response) => ({
  type: types.GET_NEWS_SUCCESS,
  response,
});

export const getNewsFailed = (response) => ({
  type: types.GET_NEWS_FAILED,
  response,
});

// getDownloadedNews
export const getDownloadedNewsRequest = () => ({
  type: types.GET_DOWNLOADED_NEWS_REQUEST,
});

export const getDownloadedNewsSuccess = (response) => ({
  type: types.GET_DOWNLOADED_NEWS_SUCCESS,
  response,
});

export const getDownloadedNewsFailed = (response) => ({
  type: types.GET_DOWNLOADED_NEWS_FAILED,
  response,
});

// postNews
export const postNewsRequest = (data) => ({
  type: types.POST_NEWS_REQUEST,
  data,
});

export const postNewsSuccess = (response) => ({
  type: types.POST_NEWS_SUCCESS,
  response,
});

export const postNewsFailed = (response) => ({
  type: types.POST_NEWS_FAILED,
  response,
});

// postFolder
export const postFolderRequest = (data) => ({
  type: types.POST_FOLDER_REQUEST,
  data,
});

export const postFolderSuccess = (response) => ({
  type: types.POST_FOLDER_SUCCESS,
  response,
});

export const postFolderFailed = (response) => ({
  type: types.POST_FOLDER_FAILED,
  response,
});

// toggleFolders
export const toggleFolders = (payload) => ({
  type: types.TOGGLE_FOLDERS,
  payload,
});

export const toggleFolderCourses = (payload) => ({
  type: types.TOGGLE_FOLDERS_COURSES,
  payload,
});

export const openMail = (payload) => ({
  type: types.OPEN_MAIL,
  payload,
});

export const toggleUserChat = (payload) => ({
  type: types.TOGGLE_USER_CHAT,
  payload,
});

// getAllContents
export const getAllContentsRequest = (id) => ({
  type: types.GET_ALL_CONTENTS_REQUEST,
  id,
});

export const getAllContentsSuccess = (response) => ({
  type: types.GET_ALL_CONTENTS_SUCCESS,
  response,
});

export const getAllContentsFailed = (response) => ({
  type: types.GET_ALL_CONTENTS_FAILED,
  response,
});

// getSlug
export const getSlugRequest = () => ({
  type: types.GET_SLUG_REQUEST,
});

export const getSlugSuccess = (response) => ({
  type: types.GET_SLUG_SUCCESS,
  response,
});

export const getSlugFailed = (response) => ({
  type: types.GET_SLUG_FAILED,
  response,
});

// getMail
export const getMailRequest = (mail_type, bool) => ({
  type: types.GET_MAIL_REQUEST,
  mail_type,
  bool,
});

export const getMailSuccess = (response) => ({
  type: types.GET_MAIL_SUCCESS,
  response,
});

export const getMailFailed = (response) => ({
  type: types.GET_MAIL_FAILED,
  response,
});

// sendMail
export const sendMailRequest = (data) => ({
  type: types.SEND_MAIL_REQUEST,
  data,
});

export const sendMailSuccess = (response) => ({
  type: types.SEND_MAIL_SUCCESS,
  response,
});

export const sendMailFailed = (response) => ({
  type: types.SEND_MAIL_FAILED,
  response,
});

// readMail
export const readMailRequest = (data) => ({
  type: types.READ_MAIL_REQUEST,
  data,
});

export const readMailSuccess = (response) => ({
  type: types.READ_MAIL_SUCCESS,
  response,
});

export const readMailFailed = (response) => ({
  type: types.READ_MAIL_FAILED,
  response,
});

// deleteMail
export const deleteMailRequest = (id, permanent_delete, mail_type) => ({
  type: types.DELETE_MAIL_REQUEST,
  id,
  permanent_delete,
  mail_type
});

export const deleteMailSuccess = (response) => ({
  type: types.DELETE_MAIL_SUCCESS,
  response,
});

export const deleteMailFailed = (response) => ({
  type: types.DELETE_MAIL_FAILED,
  response,
});

// stripeOnboard
export const stripeOnboardRequest = (data) => ({
  type: types.STRIPE_ONBOARD_REQUEST,
  data,
});

export const stripeOnboardSuccess = (response) => ({
  type: types.STRIPE_ONBOARD_SUCCESS,
  response,
});

export const stripeOnboardFailed = (response) => ({
  type: types.STRIPE_ONBOARD_FAILED,
  response,
});


// getS3Url
export const getS3UrlRequest = (data) => ({
  type: types.GET_S3_URL_REQUEST,
  data,
});

export const getS3UrlSuccess = (response) => ({
  type: types.GET_S3_URL_SUCCESS,
  response,
});

export const getS3UrlFailed = (response) => ({
  type: types.GET_S3_URL_FAILED,
  response,
});


export const clearHome = () => ({
  type: types.CLEAR_HOME,
});
